<template>
  <div>
    <div
      class="p-2 flex flex-wrap justify-end text-gray-200 relative"
      style="
        background-color: #000;
        background: linear-gradient(180deg, #000 10%, transparent);
      "
    >
      <a :href="homeURL" class="pr-2 pt-1 ml-3 text-white flex-shrink-0">
        <img
          src="/assets/imgs/logo/ranch.png"
          alt="Ranch Computing"
          width="120"
        />
      </a>
      <div class="flex-grow" />
      <!-- Support Menu -->
      <MenuDropdown class="mx-1 -mt-1" drop-class="right-0 whitespace-no-wrap">
        <template v-slot:button>
          <router-link
            :to="supportLocation"
            class="text-gray-200 py-1 px-3 rounded inline-flex items-center bg-blacko-70 group-hover:text-menu-hover"
          >
            <svg
              class="w-5 h-5 mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              ></path></svg
            ><small>Support</small></router-link
          >
        </template>
        <a
          class="px-4 py-2 flex items-center hover:bg-menu-hover"
          :href="i18n.documentation_url"
          target="_blank"
        >
          <svg
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.19 2.07h-4.13C8.62 2.07 8 3.14 8 3.21s-.62-1.14-3.06-1.14H.82a.31.31 0 0 0-.31.31v9.92a.31.31 0 0 0 .31.31h3.05A6.8 6.8 0 0 1 8 13.92a6.8 6.8 0 0 1 4.12-1.31h3.06a.3.3 0 0 0 .3-.31V2.38a.3.3 0 0 0-.29-.31zm-.73 9.33a.12.12 0 0 1-.12.12H11.6a5.39 5.39 0 0 0-3.21.94V4.32a2.65 2.65 0 0 1 2.38-1.11h3.57a.12.12 0 0 1 .12.11z"
            ></path>
            <path
              d="M11.71 4.47c-1.65 0-2.28.27-2.63.58a.2.2 0 0 0-.08.14v1c.39-.3.84-.62 2.61-.62h2.09v-1.1zM9.08 7.38a.2.2 0 0 0-.08.14v1.06c.39-.31.84-.63 2.61-.63h2.09V6.81h-2c-1.64 0-2.27.27-2.62.57zM9.08 9.72a.2.2 0 0 0-.08.14v1.06c.39-.31.84-.63 2.61-.63h2.09V9.15h-2c-1.64 0-2.27.27-2.62.57z"
            ></path>
          </svg>
          <span class="pl-2" v-text="i18n.documentation" />
        </a>
        <router-link
          :to="supportLocation"
          class="px-4 py-2 flex items-center hover:bg-menu-hover"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
            ></path>
          </svg>
          <span class="pl-2" v-text="i18n.contact_support" />
        </router-link>
      </MenuDropdown>
      <!-- Admin Menu -->
      <MenuDropdown
        v-if="user.admin_menu"
        class="mx-1 -mt-1"
        drop-class="right-0 whitespace-no-wrap"
      >
        <template v-slot:button>
          <a
            :href="user.admin_menu[1].target"
            class="text-gray-200 py-1 px-3 rounded inline-flex items-center bg-blacko-70 group-hover:text-menu-hover"
          >
            <svg
              class="w-5 h-5 mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              ></path></svg
            ><small>Admin</small></a
          >
        </template>
        <a
          v-for="item in user.admin_menu"
          :key="item.id"
          class="px-4 py-2 flex items-center hover:bg-menu-hover"
          :href="item.target"
          v-text="item.title"
        />
      </MenuDropdown>
      <!-- Old Dashboard Menu -->
      <MenuDropdown
        v-if="user.old_dashboard_menu"
        class="mx-1 -mt-1"
        drop-class="right-0 whitespace-no-wrap"
      >
        <template v-slot:button>
          <a
            :href="user.old_dashboard_menu[1].target"
            class="text-gray-200 py-1 px-3 rounded inline-flex items-center bg-blacko-70 group-hover:text-menu-hover"
          >
            <svg
              class="w-5 h-5 mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path></svg
            ><small>Legacy</small></a
          >
        </template>
        <a
          v-for="item in user.old_dashboard_menu"
          :key="item.id"
          class="px-4 py-2 flex items-center hover:bg-menu-hover"
          :href="item.target"
          v-text="item.title"
        />
      </MenuDropdown>
      <!-- User Menu -->
      <MenuDropdown class="-mt-1" drop-class="right-0 whitespace-no-wrap">
        <template v-slot:button>
          <router-link
            :to="{ name: 'settings' }"
            class="text-gray-200 py-1 px-3 rounded inline-flex items-center bg-blacko-70 cursor-pointer group-hover:text-menu-hover"
          >
            <svg
              class="w-5 h-5 mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              ></path></svg
            ><small v-text="username"
          /></router-link>
        </template>
        <router-link
          :to="{ name: 'settings' }"
          class="px-4 py-2 hover:bg-menu-hover block"
        >
          <span v-text="i18n.my_profile" />
        </router-link>
        <button
          @click="openAxeptioCookies"
          class="px-4 py-2 hover:bg-menu-hover block w-full text-left"
          v-text="i18n.tracking_consent"
        ></button>
        <a
          :href="'/' + locale + '/logout'"
          class="px-4 py-2 hover:bg-menu-hover block border-b"
        >
          <span v-text="i18n.logout" />
        </a>
        <a
          :href="'/' + locale"
          class="px-4 py-2 hover:bg-menu-hover block border-b"
        >
          <span v-text="'www.ranchcomputing.com'" />
        </a>
        <LocaleSwitcher />
      </MenuDropdown>
    </div>
    <div class="container mx-auto">
      <div class="max-w-3xl mx-auto">
        <div
          class="flex justify-around items-center py-3 text-gray-200 bg-blacko-70 rounded-t text-xs md:text-base"
        >
          <menu-item :to="dashboardRoute" :icon="['fas', 'rocket']">
            {{ i18n.dashboard }}
          </menu-item>
          <menu-item :to="queueRoute" :icon="['fas', 'tasks']">
            {{ i18n.queue }}
          </menu-item>
          <menu-item
            :to="{ name: 'invoice.welcome' }"
            icon="coins"
            class="relative"
            :class="{
              'text-red-400': safeAmount < 0.01,
              'text-orange-500': safeAmount < 15 && safeAmount >= 0.01,
            }"
          >
            <span v-html="safe" />
            <div
              v-if="hasPromotion"
              class="absolute top-0 right-0 -mt-2 text-black bg-blue-100 rounded-full md:w-6 md:h-6 md:leading-normal w-4 h-4 leading-tight bg-promo-bg text-promo-fg"
              :title="hasPromotion"
            >
              %
            </div>
          </menu-item>
          <menu-item :to="{ name: 'settings' }" icon="cogs">
            {{ i18n.settings }}
          </menu-item>
          <new-project :label="i18n.new_project"></new-project>
        </div>
      </div>
    </div>
    <UserAlert v-if="userAlert" :user-alert="userAlert" />
  </div>
</template>

<script>
import MenuDropdown from "./Commons/Dropdown";
import MenuItem from "./Menu/Item";
import NewProject from "./Menu/NewProject";
import LocaleSwitcher from "./Menu/LocaleSwitcher";
import UserAlert from "./Menu/UserAlert";

export default {
  props: ["userAlert", "hasPromotion", "i18n"],
  components: {
    MenuItem,
    MenuDropdown,
    NewProject,
    LocaleSwitcher,
    UserAlert,
  },
  methods: {
    openAxeptioCookies() {
      window.openAxeptioCookies();
    },
  },
  computed: {
    safe() {
      if (this.$store.state.account.safe !== undefined) {
        return (
          this.$store.state.account.safe.amount.formatted +
          '<span class="ranch-credit ml-1">€</span>'
        );
      }

      return "";
    },
    safeAmount() {
      if (this.$store.state.account.safe !== undefined) {
        return this.$store.state.account.safe.amount.raw;
      }

      return 0;
    },
    locale() {
      return this.$route.params.locale || "en";
    },
    homeURL() {
      return "/" + this.locale + "/";
    },
    username() {
      return this.$store.state.account.name;
    },
    user() {
      return this.$store.state.account.user;
    },
    supportLocation() {
      return {
        query: Object.assign({}, this.$route.query, {
          supportModal: 1,
        }),
      };
    },
    queueRoute() {
      const to = {
        params: {
          type: "queue",
          locale: this.$route.params.locale,
        },
      };
      if (
        this.$route.params.type === "queue" ||
        this.$route.name.substr(0, 8) !== "project."
      ) {
        to["name"] = "welcome";
      } else {
        to["name"] = this.$route.name;
        to.params["id"] = this.$route.params.id;
      }
      return to;
    },
    dashboardRoute() {
      const to = {
        params: {
          type: "projects",
          locale: this.$route.params.locale,
        },
      };
      if (
        this.$route.params.type === "projects" ||
        this.$route.name.substr(0, 8) !== "project."
      ) {
        to["name"] = "welcome";
      } else {
        to["name"] = this.$route.name;
        to.params["id"] = this.$route.params.id;
      }
      return to;
    },
  },
};
</script>
